import CallToAction from '../CallToAction'
import Link from 'components/Link'
import React from 'react'
import { Wrapper } from '../Wrapper'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'
import { MenuItem, MenuItem2 } from 'components/MainNav/Submenus/Products'

export default function Markets({ referenceElement, menuItem }) {
    const {
        customers: { nodes: customers, totalCount },
    } = useStaticQuery(query)
    const { linkList } = menuItem
    const { pathname } = useLocation()

    return (
        <Wrapper borderRadius="0px 0.375rem 0.375rem" referenceElement={referenceElement} placement="bottom-start">
            <div className="rounded-md md:flex">
                {linkList?.length > 0 &&
                    linkList.map((linkListItem, index) => {
                        const { items, title, enable } = linkListItem
                        if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
                            return <></>
                        }
                        return (
                            <section
                                key={index}
                                className="flex flex-col border-r border-dashed border-gray-accent-light p-6"
                            >
                                {items?.length > 0 &&
                                    items.map((item, index) => {
                                        const {
                                            url,
                                            subitems,
                                            enable,
                                            subtitle,
                                            subtitle_ar,
                                            title,
                                            type,
                                            style,
                                            title_ar,
                                            description,
                                            description_ar,
                                        } = item
                                        if (
                                            enable?.toLowerCase?.() === 'false' &&
                                            !process.env.RENDER_DISABLED_COMPONENTS
                                        ) {
                                            return <></>
                                        }
                                        return (
                                            <div key={index}>
                                                {type != 'CallToAction' ? (
                                                    <>
                                                        <h3 className="m-0 pl-2 text-[18px] font-bold text-black">
                                                            {title}
                                                        </h3>
                                                        <p className="text-75 mb-0  pl-2 text-sm  opacity-50 dark:text-white">
                                                            {subtitle}
                                                        </p>
                                                        <ol className="mx-0 mt-2 mb-6 grid list-none grid-cols-3 space-x-[1px] p-0">
                                                            {/* <ol className="-mx-6 mt-2 mb-6 grid list-none grid-cols-2 space-x-[1px] border-b border-dashed border-gray-accent-light p-0 px-6 pb-4 dark:border-gray-accent-dark md:grid-cols-4"> */}
                                                            {subitems?.length > 0 &&
                                                                subitems.map((subItem, index2) => {
                                                                    if (
                                                                        subItem?.toLowerCase?.() === 'false' &&
                                                                        !process.env.RENDER_DISABLED_COMPONENTS
                                                                    ) {
                                                                        return <></>
                                                                    }
                                                                    return <MenuItem2 key={index2} {...subItem} />
                                                                })}
                                                        </ol>
                                                    </>
                                                ) : (
                                                    <CallToAction
                                                        className="mt-auto inline-block !w-full"
                                                        to={subitems?.[0]?.url}
                                                    >
                                                        {title}
                                                    </CallToAction>
                                                )}
                                            </div>
                                        )
                                    })}
                            </section>
                        )
                    })}
                {/* <section className="bg-gray-accent-light bg-opacity-10 py-6 px-3">
                    <h3 className="text-[18px] font-bold m-0  pl-3">Customers</h3>
                  {items2?.length > 0 &&
                        items.map((item) => {
                            const {
                                url,
                                subitems,
                                enable,
                                subtitle,
                                subtitle_ar,
                                title,
                                type,
                                style,
                                title_ar,
                                description,
                                description_ar,
                            } = item
                                if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS)
    {
    return (<></>)
    }
                            return (
                                <div key={title}>
                                    {/* <div className="flex w-full items-center justify-between opacity-70">
                                        <>
                                            <h3 className="m-0 pl-2 text-[18px] font-bold text-black">{title}</h3>
                                            <p className="text-75 mb-0  pl-2 text-sm  opacity-50 dark:text-white">
                                                {subtitle}
                                            </p>
                                            <ol className="mx-0 mt-2 mb-6 grid list-none grid-cols-3 space-x-[1px] p-0">
                                                {subitems?.length > 0 &&
                                                    subitems.map((subItem) => {
                                                        if (subItem?.enable?.toLowerCase?.() === 'false') return <></>
                                                        return <MenuItem2 key={subItem?.title} {...subItem} />
                                                    })}
                                            </ol>
                                        </>
                                    ) : (
                                        <CallToAction className="mt-auto inline-block !w-full" to={subitems?.[0]?.url}>
                                                                   <span>All customers</span>{' '}
                        <span className="opacity-50">
                            (<span className="inline-block mx-0">{totalCount}</span>)
                        </span>
                                        </CallToAction>
                                    )}
                                </div>
                            )
                        })}
                    </CallToAction>
                </section> */}
            </div>
        </Wrapper>
    )
}

const query = graphql`
    {
        customers: allMdx(filter: { fields: { slug: { regex: "/^/customers/" } } }, limit: 3) {
            nodes {
                id
                fields {
                    slug
                }
                frontmatter {
                    logo {
                        childImageSharp {
                            gatsbyImageData(placeholder: NONE)
                        }
                    }
                    title
                }
            }
            totalCount
        }
    }
`
